/* Two things the mobile drawer needs that Liquid cannot supply on its own.

   1. THE TICKER STRIP.
      The design's drawer (`.header__drawer` in the static export) opens as a full-screen
      sheet with the announcement ticker as its FIRST child — so the strip appears to stay
      put while the sheet slides over everything else. Our drawer is a full-screen sheet
      too, and it covers the announcement bar, but it had no ticker of its own, so the
      strip simply vanished when the menu opened.

      The obvious fix — render `snippets/nooa-ticker.liquid` a second time inside the
      drawer — is not available: the drawer is part of the HEADER section and the ticker's
      items are blocks of the ANNOUNCEMENT-BAR section, and Liquid cannot read another
      section's settings. Duplicating the items as header settings would mean the merchant
      typing the same four announcements twice and them drifting apart.

      So the strip is cloned from the one already in the DOM. One source of content, no new
      settings, and edits in the theme editor reach both copies.

   2. THE CART COUNT.
      The drawer's cart link showed the bag with no number, so with items in the cart the
      drawer said the cart was empty. The design has no bubble because the static has no
      cart; this is a real-store need, not a design element, which is why the markup for it
      sits beside Dawn's own in `snippets/header-drawer.liquid` and the positioning sits in
      `nooa-overrides.css` beside the bar's bubble.

      Liquid renders it correctly on load. Keeping it correct AFTER an add-to-cart is the
      part that needs script: Dawn re-renders only `#cart-icon-bubble` (see
      sections/cart-icon-bubble.liquid), so the bar's bubble updates and the drawer's copy
      would sit stale until the next full page load. It is mirrored from the bar instead of
      being fetched separately — the bar's number is by definition the fresh one.
*/
(function () {
  var DRAWER = '.menu-drawer.header__drawer';

  /* ---- 1. Ticker ---- */

  function buildTicker() {
    var inner = document.querySelector(DRAWER + ' .menu-drawer__inner-container');
    if (!inner || inner.querySelector('.header__drawer-ticker')) return;

    var source = document.querySelector('.announcement-bar [data-marquee-type="ticker"]');
    if (!source) return;

    /* Clone the INITIAL child container, never the whole ticker. nooa-marquee.js fills the
       two `.marquee-ticker` tracks with copies of this container to make the loop seamless,
       so a clone of the live ticker would carry those copies in and the script would then
       repeat them again. The initial container is the only node that still holds exactly
       the authored items. */
    var items = source.querySelector('.marquee-ticker-initial-child-container');
    if (!items) return;

    var root = document.createElement('div');
    root.className = 'header__drawer-ticker marquee-slider marquee-ticker-container';
    root.setAttribute('data-marquee-type', 'ticker');
    root.setAttribute('data-marquee-ticker-pause', source.getAttribute('data-marquee-ticker-pause') || 'true');
    root.setAttribute('data-marquee-ticker-speed', source.getAttribute('data-marquee-ticker-speed') || '60');

    var primary = document.createElement('div');
    primary.className = 'marquee-ticker';
    primary.appendChild(items.cloneNode(true));

    /* The second track ships EMPTY — nooa-marquee.js fills it, and authoring content into
       it is what the snippet's own comment warns against. */
    var secondary = document.createElement('div');
    secondary.className = 'marquee-ticker';

    root.appendChild(primary);
    root.appendChild(secondary);
    inner.insertBefore(root, inner.firstChild);

    /* `__marqueeInitTicker` looks for tickers INSIDE what it is given, so it is handed the
       container rather than the ticker itself. */
    if (window.__marqueeInitTicker) window.__marqueeInitTicker(inner);
  }

  /* Built on first open, not on load. A closed <details> gives its contents no box, so the
     marquee would measure a zero-width track and compute a zero duration — the strip would
     be there and never move. By the time `toggle` fires the sheet has its real size. */
  function watchDrawer() {
    var details = document.querySelector(DRAWER).closest('details');
    if (!details) return;
    details.addEventListener('toggle', function () {
      if (details.open) buildTicker();
    });
    if (details.open) buildTicker();
  }

  /* ---- 2. Cart count ---- */

  function mirrorCartCount() {
    var source = document.getElementById('cart-icon-bubble');
    var target = document.querySelector('.header__drawer-cart');
    if (!source || !target) return;

    var fresh = source.querySelector('.cart-count-bubble');
    var stale = target.querySelector('.cart-count-bubble');

    if (!fresh) {
      if (stale) stale.remove();
      return;
    }
    var copy = fresh.cloneNode(true);
    if (stale) target.replaceChild(copy, stale);
    else target.appendChild(copy);
  }

  function watchCartCount() {
    var source = document.getElementById('cart-icon-bubble');
    if (!source || !window.MutationObserver) return;
    /* Dawn swaps the whole contents of #cart-icon-bubble for the re-rendered section, so a
       childList observer on it is enough; there is no event to subscribe to for this. */
    new MutationObserver(mirrorCartCount).observe(source, { childList: true, subtree: true });
  }

  function init() {
    if (!document.querySelector(DRAWER)) return;
    watchDrawer();
    watchCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
